const StackQueue = [
    {
      Topic: "Stacks & Queues",
      Problem: " Implement Stack from Scratch",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.tutorialspoint.com/javaexamples/data_stack.htm",
      URL2: "https://www.codingninjas.com/codestudio/problems/stack-implementation-using-array_3210209?topList=love-babbar-dsa-sheet-problems",
      Id: 1
    },
    {
      Topic: "Stacks & Queues",
      Problem: " Implement Queue from Scratch",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/queue-set-1introduction-and-array-implementation/",
      URL2: "https://www.codingninjas.com/codestudio/problems/queue-using-array-or-singly-linked-list_2099908?topList=love-babbar-dsa-sheet-problems",
      Id: 2
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Implement 2 stack in an array",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/implement-two-stacks-in-an-array/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/two-stacks_983634?topList=love-babbar-dsa-sheet-problems",
      Id: 3
    },
    {
      Topic: "Stacks & Queues",
      Problem: "find the middle element of a stack",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/design-a-stack-with-find-middle-operation/",
      URL2: "https://www.codingninjas.com/codestudio/problems/delete-middle-element-from-stack_985246?topList=love-babbar-dsa-sheet-problems",
      Id: 4
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Implement \"N\" stacks in an Array",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/efficiently-implement-k-stacks-single-array/",
      URL2: "https://www.codingninjas.com/codestudio/problems/n-stacks-in-an-array_1164271?topList=love-babbar-dsa-sheet-problems",
      Id: 5
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Check the expression has valid or Balanced parenthesis or not.",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/parenthesis-checker/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/kevin-s-stack-problem_1169465?topList=love-babbar-dsa-sheet-problems",
      Id: 6
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Reverse a String using Stack",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/reverse-a-string-using-stack/1",
      URL2: "",
      Id: 7
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Design a Stack that supports getMin() in O(1) time and O(1) extra space.",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/special-stack/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/design-a-stack-that-supports-getmin-in-o-1-time-and-o-1-extra-space_842465?topList=love-babbar-dsa-sheet-problems",
      Id: 8
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Find the next Greater element",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/next-larger-element/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/next-greater-element_670312?topList=love-babbar-dsa-sheet-problems",
      Id: 9
    },
    {
      Topic: "Stacks & Queues",
      Problem: "The celebrity Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/the-celebrity-problem/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/the-celebrity-problem_982769?topList=love-babbar-dsa-sheet-problems",
      Id: 10
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Arithmetic Expression evaluation",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/arithmetic-expression-evalution/",
      URL2: "https://www.codingninjas.com/codestudio/problems/arithmetic-expression-evaluation_1170517?topList=love-babbar-dsa-sheet-problems",
      Id: 11
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Evaluation of Postfix expression",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/evaluation-of-postfix-expression/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/evaluation-of-postfix-expression_841358?topList=love-babbar-dsa-sheet-problems",
      Id: 12
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Implement a method to insert an element at its bottom without using any other data structure.",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/program-to-insert-an-element-at-the-bottom-of-a-stack/",
      URL2: "https://www.codingninjas.com/codestudio/problems/insert-an-element-at-its-bottom-in-a-given-stack_1171166?topList=love-babbar-dsa-sheet-problems",
      Id: 13
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Reverse a stack using recursion",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/reverse-a-stack-using-recursion/",
      URL2: "https://www.codingninjas.com/codestudio/problems/reverse-stack-using-recursion_631875?topList=love-babbar-dsa-sheet-problems",
      Id: 14
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Sort a Stack using recursion",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/sort-a-stack/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/sort-a-stack_985275?topList=love-babbar-dsa-sheet-problems",
      Id: 15
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Merge Overlapping Intervals",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/8a644e94faaa94968d8665ba9e0a80d1ae3e0a2d/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/merge-overlapping-intervals_1082151?topList=love-babbar-dsa-sheet-problems",
      Id: 16
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Largest rectangular Area in Histogram",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/maximum-rectangular-area-in-a-histogram/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/largest-rectangle-in-a-histogram_1058184?topList=love-babbar-dsa-sheet-problems",
      Id: 17
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Length of the Longest Valid Substring",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/valid-substring0624/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/valid-substring_1172217?topList=love-babbar-dsa-sheet-problems",
      Id: 18
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Expression contains redundant bracket or not",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/expression-contains-redundant-bracket-not/",
      URL2: "https://www.codingninjas.com/codestudio/problems/ninja-and-a-complex-expression_1170758?topList=love-babbar-dsa-sheet-problems",
      Id: 19
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Implement Stack using Queue",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/stack-using-two-queues/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/stack-using-queue_795152?topList=love-babbar-dsa-sheet-problems",
      Id: 20
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Implement Stack using Deque",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/implement-stack-queue-using-deque/",
      URL2: "https://www.codingninjas.com/codestudio/problems/stack-using-deque_1170512?topList=love-babbar-dsa-sheet-problems",
      Id: 21
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Stack Permutations (Check if an array is stack permutation of other)",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/stack-permutations-check-if-an-array-is-stack-permutation-of-other/",
      URL2: "https://www.codingninjas.com/codestudio/problems/valid-stack-permutation_1170061?topList=love-babbar-dsa-sheet-problems",
      Id: 22
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Implement Queue using Stack  ",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/queue-using-two-stacks/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/queue-using-two-stacks_1170062?topList=love-babbar-dsa-sheet-problems",
      Id: 23
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Implement \"n\" queue in an array",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/efficiently-implement-k-queues-single-array/",
      URL2: "https://www.codingninjas.com/codestudio/problems/n-queue-using-array_1170053?topList=love-babbar-dsa-sheet-problems",
      Id: 24
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Implement a Circular queue",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/circular-queue-set-1-introduction-array-implementation/",
      URL2: "https://www.codingninjas.com/codestudio/problems/circular-queue_1170058?topList=love-babbar-dsa-sheet-problems",
      Id: 25
    },
    {
      Topic: "Stacks & Queues",
      Problem: "LRU Cache Implementationa",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/lru-cache/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/lru-cache-implementation_670276?topList=love-babbar-dsa-sheet-problems",
      Id: 26
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Reverse a Queue using recursion",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/queue-reversal/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/reversing-queue_1170046?topList=love-babbar-dsa-sheet-problems",
      Id: 27
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Reverse the first “K” elements of a queue",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/reverse-first-k-elements-of-queue/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/reverse-the-first-k-elements-of-a-queue_1164269?topList=love-babbar-dsa-sheet-problems",
      Id: 28
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Interleave the first half of the queue with second half",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/interleave-first-half-queue-second-half/",
      URL2: "https://www.codingninjas.com/codestudio/problems/interleave-the-first-half-of-the-queue-with-the-second-half_1169450?topList=love-babbar-dsa-sheet-problems",
      Id: 29
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Find the first circular tour that visits all Petrol Pumps",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/circular-tour/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/find-the-first-circular-tour-that-visits-all-the-petrol-pumps_799923?topList=love-babbar-dsa-sheet-problems",
      Id: 30
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Minimum time required to rot all oranges",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/rotten-oranges/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/rotting-oranges_701655?topList=love-babbar-dsa-sheet-problems",
      Id: 31
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Distance of nearest cell having 1 in a binary matrix",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/distance-of-nearest-cell-having-1/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/distance-of-nearest-cell-having-1-in-a-binary-matrix_1169913?topList=love-babbar-dsa-sheet-problems",
      Id: 32
    },
    {
      Topic: "Stacks & Queues",
      Problem: "First negative integer in every window of size “k”",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/first-negative-integer-in-every-window-of-size-k/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/first-negative-integer-in-every-window-of-size-k_1164406?topList=love-babbar-dsa-sheet-problems",
      Id: 33
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Check if all levels of two trees are anagrams or not.",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/check-if-all-levels-of-two-trees-are-anagrams-or-not/",
      URL2: "https://www.codingninjas.com/codestudio/problems/check-if-all-levels-of-two-trees-are-anagrams-of-each-other-not_1214546?topList=love-babbar-dsa-sheet-problems",
      Id: 34
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Sum of minimum and maximum elements of all subarrays of size “k”.",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/sum-minimum-maximum-elements-subarrays-size-k/",
      URL2: "https://www.codingninjas.com/codestudio/problems/sum-of-minimum-and-maximum-elements-of-all-subarrays-of-size-k_1171047?topList=love-babbar-dsa-sheet-problems",
      Id: 35
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Minimum sum of squares of character counts in a given string after removing “k” characters.",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/game-with-string/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimum-sum-of-squares_1170763?topList=love-babbar-dsa-sheet-problems",
      Id: 36
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Queue based approach or first non-repeating character in a stream.",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/first-non-repeating-character-in-a-stream/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/first-unique-character-in-a-string_982933?topList=love-babbar-dsa-sheet-problems",
      Id: 37
    },
    {
      Topic: "Stacks & Queues",
      Problem: "Next Smaller Element",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/next-smaller-element/",
      URL2: "https://www.codingninjas.com/codestudio/problems/next-smaller-element_1112581?topList=love-babbar-dsa-sheet-problems",
      Id: 38
    }
  ];

export default StackQueue;